<div class="fixed scrollable-container">
	<div style=" max-width: 800px;" class="container">
	 

		<div  *ngIf="!loading; else load" >
			 
			<div *ngIf="waitPassword" class="enterPasswordWrapp">
				<div class="enterPassword">
					<div>
					   <input placeholder="Пароль" type="password" nbInput [(ngModel)]="password" />
					   <button nbButton status="primary" (click)="loadWithPass()" >Увійти</button>
					</div>

 					<div style="margin-top:5px; font-size:12px;" class="text-danger" *ngIf="passwordError">
					   {{passwordError}}
					</div>
				</div>	
			</div>




		 <div *ngIf="partner">

		  <div class="row">

		    <div  class="col-xs-12 col-md-6" >
	 	
					
				<nb-card>
				      
				    <nb-card-body> 
					<p class="head text-center">Баланс:</p>
					<p class="text text-center">{{partner.balance | number:'1.2'}}  грн.</p>
 
				    </nb-card-body> 

				</nb-card>
		    </div>

		    <div class="col-xs-12 col-md-6" >
	 		<nb-card>
				      
				    <nb-card-body> 

					<p class="head text-center">Промокод</p>
					<p class="text text-center">{{partner.promocodePut === true ? partner.promocode : '------'}} </p>
 
				    </nb-card-body> 

				</nb-card>

		    </div>
	
		  </div>

		 <div class="row">

				    <div class="col-12" >

			 		<nb-card>
						      
						    <nb-card-body> 

							<table  style="width: 100%;">
							<thead>
							<tr><td>Дата</td><td>Поповнення</td><td>Винагорода</td></tr>		
							</thead>

							<tbody>
								<tr *ngFor="let item of partner.saleItems" >
									<td>{{item.created_at | date:'dd.MM.yyyy - HH:mm'}}</td>
									<td>{{item.amount | number:'1.2'}}  грн.</td>
									<td>{{item.award | number:'1.2'}}  грн.</td>
								</tr>		
							</tbody>

							</table>				

							<p class="text-center" style="margin-top:30px" *ngIf="!partner.saleItems?.length" >Немає даних</p>
						    </nb-card-body> 

						</nb-card>

				    </div>
			 
			</div>
  		
			</div>
  		
 
 


		</div>
	</div>
</div>

<ng-template #load>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div>
</ng-template> 

